import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import Modal from "../components/Modal";
import api from "../service/api";
import { setError, setWarning } from "../reducers/appSlice";

const VerificarUltimoAdjunto = ({tramiteId, verficarElFirmado, verficarElFirmadoCancelar}) => {

  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [firmas, setFirmas] = useState(false);
  
  const handleClose = () => {setOpen(false); verficarElFirmadoCancelar()};

   const verificar = () => {
    api
      .verificarUltimoAdjunto({ 
        tramiteId: tramiteId 
      })
      .then((res) => {
        if (res.data === true) {
          setFirmas(true);
         }else{
           verficarElFirmado();
         }
      })
      .catch((e) =>
        dispatch(
          setError(e.response.data.error ? e.response.data.error : "Error")
        )
      )
      .finally(() => setSubmitting(false));
  };

 useEffect(() => {
    verificar()
  }, []);

  return (
    <>
    {firmas ? (
        <Modal open={open} handleClose={handleClose} size="sm">
        <Typography variant="titulo" paragraph>
          Documento adjunto sin firma digital
        </Typography>
        <Typography variant="cuerpo" paragraph>
          El expediente contiene uno o más documentos adjuntos que requieren firma digital según Resolución 6/23 S.M. ¿Deseas continuar?
        </Typography>
        {/* <Typography variant="cuerpo" paragraph>
          El documento adjuntado debería estar firmado digitalmente. ¿Querés continuar?
        </Typography> */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          <Button sx={{ m: 1 }} variant="verde" onClick={verficarElFirmado}>
            {"Confirmar"}
          </Button>
          <Button sx={{ m: 1 }} variant="plata" onClick={handleClose}>
            {"Cancelar"}
          </Button>
        </Box>
      </Modal>
    ): null}
    </>
  );
};

export default VerificarUltimoAdjunto;